import { IPSpinner } from 'baseComponents';
import { IPSpinnerSize } from 'baseComponents/Spinner/IPSpinner';
import { IPStack } from 'baseComponents/Stack/IPStack';

interface IAppLoaderProps {}

//
// Main render
//
const AppLoader = (props: IAppLoaderProps) => {
  return (
    <IPStack styles={{ root: { height: '100vh' } }} verticalAlign="center" horizontalAlign="center">
      <IPStack.Item>
        <IPSpinner size={IPSpinnerSize.large} />
      </IPStack.Item>
    </IPStack>
  );
};

export default AppLoader;
